import MyTable from 'components/UIElements/MyTable';

export default function Status({ endPoint, exportFilename }) {
  const columns = [
    {
      title: 'PolicyNo',
      key: 'policyNumber',
      dataIndex: 'policyNumber'
    },
    {
      title: 'PlateNo',
      key: 'plateNumber',
      dataIndex: 'plateNumber'
    },
    {
      title: 'OBD',
      key: 'deviceImei',
      dataIndex: 'deviceImei'
    },
    {
      title: 'Channel',
      key: 'channel',
      dataIndex: 'channel'
    },
    {
      title: 'Start_Contract',
      key: 'contractStartDate',
      dataIndex: 'contractStartDate'
    },
    {
      title: 'End_Contract',
      key: 'contractEndDate',
      dataIndex: 'contractEndDate'
    },
    {
      title: 'SMS_Date',
      key: 'smsDate',
      dataIndex: 'smsDate'
    },
    {
      title: 'SMS',
      key: 'smsType',
      dataIndex: 'smsType'
    },
    {
      title: 'Status_SMS',
      key: 'smsStatus',
      dataIndex: 'smsStatus'
    },
    {
      title: 'DeviceStatus',
      key: 'deviceStatus',
      dataIndex: 'deviceStatus'
    },
    {
      title: 'isDeleted',
      key: 'isGdprDeleted',
      dataIndex: 'isGdprDeleted'
    },
    {
      title: 'Status_Contract',
      key: 'isActive',
      dataIndex: 'isActive'
    },
    {
      title: 'Klm_Contract',
      key: 'contractDuration',
      dataIndex: 'contractDuration'
    },
    {
      title: 'Devices',
      key: 'totalDevicesCount',
      dataIndex: 'totalDevicesCount'
    },
    {
      title: 'Klm_Covered',
      key: 'kilometers',
      dataIndex: 'kilometers'
    },
    {
      title: 'DeviceType',
      key: 'deviceType',
      dataIndex: 'deviceType'
    }
  ];

  return (
    <MyTable
      columns={columns}
      endPoint={endPoint}
      exportFilename={exportFilename}
    />
  );
}
